import React from "react";
import { NavLink, Route, Switch, Redirect } from "react-router-dom";
import ConversationsList from "./ConversationsList";
import "./conversations.css";

const ShopConversations = () => {
  return (
    <div className="conversationsShell">
      <nav className="conversationsTabs">
        <NavLink
          className="conversationsTab"
          activeClassName="isActive"
          to="/shopAdmin/tickets/UnrepliedTickets"
        >
          Unreplied
        </NavLink>
        <NavLink className="conversationsTab" activeClassName="isActive" to="/shopAdmin/tickets/RepliedTickets">
          Replied
        </NavLink>
        <NavLink className="conversationsTab" activeClassName="isActive" to="/shopAdmin/tickets/ClosedTickets">
          Closed
        </NavLink>
      </nav>

      <Switch>
        <Route
          exact
          path="/shopAdmin/tickets/UnrepliedTickets"
          render={() => <ConversationsList key="unreplied" status="unreplied" />}
        />
        <Route
          exact
          path="/shopAdmin/tickets/RepliedTickets"
          render={() => <ConversationsList key="replied" status="replied" />}
        />
        <Route
          exact
          path="/shopAdmin/tickets/ClosedTickets"
          render={() => <ConversationsList key="closed" status="closed" />}
        />
        <Redirect from="/shopAdmin/tickets" to="/shopAdmin/tickets/UnrepliedTickets" />
      </Switch>
    </div>
  );
};

export default ShopConversations;
